import { useEffect } from 'react';

// Ajusta el tamaño de las cards según el DPR del monitor.
// Monitor grande (DPR bajo) → cards más pequeñas para compensar pantalla física mayor.
// Referencia: DPR 1.375 (monitor pequeño) = factor 1.0 (sin cambio)
const DPR_REF = 1.375;

function calcular() {
  const dpr    = window.devicePixelRatio || 1;
  const vw = window.innerWidth / 100;

  const cardW   = Math.round(Math.max(200, Math.min(16.2 * vw, 310)));
  const h1      = Math.round(Math.max(138, Math.min(11.2 * vw, 214)));
  const h2      = Math.round(Math.max(69,  Math.min(5.6  * vw, 107)));
  const root = document.documentElement;
  root.style.setProperty('--card-w',  cardW + 'px');
  root.style.setProperty('--card-h1', h1    + 'px');
  root.style.setProperty('--card-h2', h2    + 'px');
}

export default function useCardScale() {
  useEffect(() => {
    calcular();
    window.addEventListener('resize', calcular);
    return () => window.removeEventListener('resize', calcular);
  }, []);
}
